import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  REFERRAL_METRIC_CARD_PROPS,
  REFERRAL_METRIC_CARD_DEFAULT_PROPS,
} from "./ShareReferrals.types";

export const ReferralMetricCard = ({
  icon,
  iconLabel,
  title,
  value,
  bgClass,
  titleClass,
  loaderColor,
  isLoading,
}) => (
  <div
    className={`tw-rounded-2xl tw-p-5 sm:tw-p-6 tw-flex tw-flex-col tw-justify-between ${bgClass}`}
  >
    <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
      <span className="tw-text-xl" role="img" aria-label={iconLabel}>
        {icon}
      </span>
      <span
        className={`tw-text-xs sm:tw-text-sm tw-font-semibold ${titleClass}`}
      >
        {title}
      </span>
    </div>
    <div className="tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-tracking-tight">
      {isLoading ? (
        <CircularProgress size={24} style={{ color: loaderColor }} />
      ) : (
        value
      )}
    </div>
  </div>
);

ReferralMetricCard.propTypes = REFERRAL_METRIC_CARD_PROPS;
ReferralMetricCard.defaultProps = REFERRAL_METRIC_CARD_DEFAULT_PROPS;
